import rootExtractor from "@Dataset/rootExtractor";
import getCookie from "@Cookies/functions/getCookie";
import {convertArrayToObject} from "@Array/convertArrayToObject";
import {CookieCategoryType} from "@Cookies/types/CookieCategory.type";

export default function getActiveCookiesFromCookieData() {
    const cookieData = JSON.parse(rootExtractor('cookieData')) as CookieCategoryType[]

    const cookieKeys: {cookieKey: string, active: boolean, canBeToggled: boolean}[] = cookieData.map(({cookieKey, cookies, canBeToggled}) => {
        const key = {
            cookieKey,
            active: getCookie(cookieKey) ?? true,
            canBeToggled,
        }
        const individualCookieKeys = cookies.map(({cookieKey}) => ({
            cookieKey,
            active: getCookie(cookieKey) ?? true,
            canBeToggled,
        }))

        return [key, ...individualCookieKeys]
    }).flat(Infinity)

    const keysThatCanBeToggled = cookieKeys.filter((key) => key.canBeToggled ?? key)
    const cookieKeysArray = cookieKeys.map((key) => ({[key.cookieKey]: key.active}))

    return {
        cookieData,
        keysThatCanBeToggled,
        cookieKeysArray,
        cookieKeys: convertArrayToObject(cookieKeysArray),
    }
}